import { logWrapper } from '../utils';

function sidebarToggleDirectiveFactory(runtimeConstant, $timeout) {
  // eslint-disable-next-line no-unused-vars
  function link(scope, element) {

    // Atraso para garantir que jQuery e DOM estejam prontos
    $timeout(() => {
      if (!window.jQuery) {
        return;
      }

      const body = jQuery('body');

      // Menu/Chat toggle
      body.on('click', '#menu-trigger, #chat-trigger', function (e) {
        e.preventDefault(); // Impede o comportamento padrão

        const triggerElem = jQuery(this);  // Elemento clicado (menu ou chat)
        const targetSelector = triggerElem.data('trigger'); // Alvo a ser ativado
        let elem = '';
        let elem2 = '';

        // Alterna a classe 'toggled' no alvo
        jQuery(targetSelector).toggleClass('toggled');
        triggerElem.toggleClass('open');

        // Fecha submenus não ativos
        jQuery('.sub-menu.toggled').not('.active').each(function () {
          jQuery(this).removeClass('toggled');
          jQuery(this).find('ul').hide();
        });

        // Esconde menu de perfil
        jQuery('.profile-menu .main-menu').hide();

        // Caso o alvo seja o sidebar
        if (targetSelector === '#sidebar') {
          elem = '#sidebar';
          elem2 = '#menu-trigger';

          jQuery('#chat-trigger').removeClass('open');  // Fecha o chat, caso esteja aberto

          if (!jQuery('#chat').hasClass('toggled')) {
            jQuery('#header').toggleClass('sidebar-toggled');  // Alterna a visibilidade do sidebar
          } else {
            jQuery('#chat').removeClass('toggled');  // Se o chat estiver aberto, fecha-o
          }
        }

        // Caso o alvo seja o chat
        if (targetSelector === '#chat') {
          elem = '#chat';
          elem2 = '#chat-trigger';

          jQuery('#menu-trigger').removeClass('open');  // Fecha o menu, caso esteja aberto

          if (!jQuery('#sidebar').hasClass('toggled')) {
            jQuery('#header').toggleClass('sidebar-toggled');  // Alterna a visibilidade do sidebar
          } else {
            jQuery('#sidebar').removeClass('toggled');  // Fecha o sidebar se estiver aberto
          }
        }

        // Fecha ao clicar fora
        if (jQuery('#header').hasClass('sidebar-toggled')) {
          jQuery(document).on('click.sidebar', function (e) {
            if (
              jQuery(e.target).closest(elem).length === 0 &&
              jQuery(e.target).closest(elem2).length === 0
            ) {
              setTimeout(() => {
                jQuery(elem).removeClass('toggled');
                jQuery('#header').removeClass('sidebar-toggled');
                jQuery(elem2).removeClass('open');
              });

              jQuery(document).off('click.sidebar');
            }
          });
        }
      });

      // Submenu toggle
      body.on('click', '.sub-menu > a', function (e) {
        e.preventDefault();
        jQuery(this).next().slideToggle(200);
        jQuery(this).parent().toggleClass('toggled');
      });
    }, 1000); // Atraso de 1000ms para garantir o carregamento do jQuery
  }

  function run() {
    try {
      return {
        restrict: 'A',
        link,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const sidebarToggleDirective = ['runtimeConstant', '$timeout', sidebarToggleDirectiveFactory];
